import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../shared/functions/formatDate';
import { handleError } from '../../shared/functions/handleError';
import { AdminUserService } from '../user/service';

const dashboardKeys = [
  'warningTrucks',
  'warningTrailers',
  'totalTrucks',
  'totalTrailers',
  'totalUsers',
];

const AdminDashboardPage = () => {
  const { t } = useTranslation();
  const [dashboardData, setDashboardData] = useState({
    totalTrucks: 0,
    totalTrailers: 0,
    totalUsers: 0,
    warningTrailers: 0,
  });
  useEffect(() => {
    AdminUserService.getDashboardData()
      .then(setDashboardData)
      .catch(handleError);
  }, []);
  return (
    <Row>
      {dashboardKeys?.map((key) => (
        <Col md={4} key={key} className="mb-3">
          <Card>
            <Card.Body>
              <Card.Text>
                {t(`general.${key}`)}:{' '}
                <b>{dashboardData[key as keyof typeof dashboardData]}</b>
              </Card.Text>
            </Card.Body>
            <Card.Footer>
              <Card.Text>
                {t('general.updatedAt')}:{' '}
                {formatDate(new Date()?.toISOString())}
              </Card.Text>
            </Card.Footer>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default AdminDashboardPage;
